const comments = [
  {
    name: '吃瓜群众甲',
    time: '15分钟前',
    content: '这个网站太猛了，每天刷一刷比看综艺还刺激！网红塌房的速度真的比我吃瓜的速度还快，51吃瓜黑料网址入口已经设成浏览器首页了。',
    likes: 892,
    tag: '忠实用户',
  },
  {
    name: '深夜吃瓜人',
    time: '42分钟前',
    content: '昨晚那个网曝门爆料看完整个人都震惊了，没想到表面上光鲜亮丽的博主背后竟然是这样的。51吃瓜黑料爆料的整理速度真的快，全网第一！',
    likes: 654,
    tag: '活跃读者',
  },
  {
    name: '八卦研究员',
    time: '1小时前',
    content: '作为吃瓜老手，51吃瓜黑料是我见过内容最全、更新最快的平台。明星爆料、博主反差、网红黑料一条龙，每天都在刷新我的认知上限。',
    likes: 521,
    tag: '资深瓜友',
  },
  {
    name: '每日打卡选手',
    time: '2小时前',
    content: '已经连续在51吃瓜黑料打卡30天了！每天午休和睡前必刷，不打烊更新是真的良心。昨天那个塌房时间线整理得特别清楚，给小编加鸡腿！',
    likes: 438,
    tag: '忠实用户',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            读者热评
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((c) => (
            <div
              key={c.name}
              className="p-5 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                    <i className="ri-user-line text-secondary-600"></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                        {c.name}
                      </span>
                      <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-600 whitespace-nowrap">
                        {c.tag}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {c.time}
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {c.content}
              </p>
              <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                <button className="flex items-center gap-1 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{c.likes}</span>
                </button>
                <button className="flex items-center gap-1 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span className="whitespace-nowrap">回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}